import React from 'react';

type BadgeVariant = 'active' | 'running' | 'complete' | 'pending' | 'warning' | 'error' | 'idle' | 'approved' | 'submitted' | 'correction';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
  pulse?: boolean;
}

const variantMap: Record<BadgeVariant, { bg: string; text: string; dot: string; defaultLabel: string }> = {
  active:     { bg: 'bg-success/10',  text: 'text-success',  dot: 'bg-success',  defaultLabel: 'Active' },
  running:    { bg: 'bg-success/10',  text: 'text-success',  dot: 'bg-success',  defaultLabel: 'Running' },
  complete:   { bg: 'bg-secondary/10', text: 'text-secondary', dot: 'bg-secondary', defaultLabel: 'Complete' },
  pending:    { bg: 'bg-warning/10',  text: 'text-warning',  dot: 'bg-warning',  defaultLabel: 'Pending' },
  warning:    { bg: 'bg-warning/10',  text: 'text-warning',  dot: 'bg-warning',  defaultLabel: 'Warning' },
  error:      { bg: 'bg-danger/10',   text: 'text-danger',   dot: 'bg-danger',   defaultLabel: 'Error' },
  idle:       { bg: 'bg-muted',       text: 'text-muted-foreground', dot: 'bg-muted-foreground', defaultLabel: 'Idle' },
  approved:   { bg: 'bg-success/10',  text: 'text-success',  dot: 'bg-success',  defaultLabel: 'Approved' },
  submitted:  { bg: 'bg-secondary/10', text: 'text-secondary', dot: 'bg-secondary', defaultLabel: 'Submitted' },
  correction: { bg: 'bg-danger/10',   text: 'text-danger',   dot: 'bg-danger',   defaultLabel: 'Correction Req.' },
};

export default function StatusBadge({ variant, label, size = 'sm', pulse = false }: StatusBadgeProps) {
  const v = variantMap[variant];
  const sizeClass = size === 'md' ? 'px-3 py-1 text-xs' : 'px-2 py-0.5 text-xs';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${v.bg} ${v.text} ${sizeClass}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${v.dot} ${pulse ? 'pulse-dot' : ''}`} />
      {label ?? v.defaultLabel}
    </span>
  );
}